import axios from 'axios'

const api = axios.create({
  baseURL: '/tracer',
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
})

const tokenBasedApi = axios.create({
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
})

export function apiGetBlockDiagramGraph({ vin, subsystemId }) {
  const params = new URLSearchParams({ vin, subsystem_id: subsystemId })

  return api
    .get(`/block-diagram?${params.toString()}`)
    .then((response) => response.data)
}

export function apiGetDetailDiagramGraph({ vin, componentA, componentB }) {
  const params = new URLSearchParams({
    vin,
    component_a: componentA,
    component_b: componentB,
  })

  return api
    .get(`/block-diagram-detail?${params.toString()}`)
    .then((response) => response.data)
}

export function apiGetComponentDetailDiagramGraph({
  vin,
  subsystemCode,
  componentId,
  pins,
}) {
  const params = new URLSearchParams({ vin, subsystem_code: subsystemCode })
  if (componentId) {
    params.append('component_id', componentId)
  }
  if (pins) {
    params.append('pins', pins.join(','))
  }

  return api
    .get(`/block-diagram-component-detail?${params.toString()}`)
    .then((response) => response.data)
}

export function apiGetSubsystems({ vin }) {
  return api.get(`/subsystems/${vin}`).then((resp) => resp.data)
}

export function apiGetSubsystemByCode({ vin, subsystemCode }) {
  const params = new URLSearchParams({ subsystem_code: subsystemCode })
  return api
    .get(`/subsystems/${vin}/by-code?${params.toString()}`)
    .then((resp) => resp.data)
}

// `pins` resolves the search through those pins: a device or inline is not itself
// mappable into a subsystem, so the backend answers for the connectors its picked
// pins reach. Omitting them keeps the plain component search.
export function apiGetSubsystemsSearch({ vin, componentId, pins = [] }) {
  const params = new URLSearchParams({ component_id: componentId })
  if (pins.length > 0) params.set('pins', pins.join(','))
  return api
    .get(`/subsystems/${vin}/search?${params.toString()}`)
    .then((resp) => resp.data)
}

export function apiGetConnectorPinout({ requestBody }) {
  return api
    .post(`/block-diagram-pinout`, requestBody)
    .then((resp) => resp.data)
}

export function apiGetComponentNeighbors({ vin, componentId }) {
  const params = new URLSearchParams({ vin, component_id: componentId })
  return api
    .get(`/block-diagram-neighbors?${params.toString()}`)
    .then((resp) => resp.data)
}

export function apiGetTokenBasedBlockDiagramGraph({
  authToken,
  componentHashId,
}) {
  return tokenBasedApi
    .get(`/api/v1/block-diagram?id=${componentHashId}`, {
      headers: { Authorization: `Bearer ${authToken}` },
    })
    .then((response) => response.data)
}
